// 为避免 ESM 分包后 util 与 ui 的循环依赖，这里内联定义 LEGEND_TYPE，保持与 ui/legend.ShowType 的枚举值一致
export const LEGEND_TYPE = {
  Line: 0,
  Rect: 1,
  Round: 2,
  RoundWithLine: 3,
  KLine: 4
} as const;

export const LAYOUT = {
  /** 1*1 */
  SMALL: 'sm-1*1',
  /** 2*1 */
  SMALL_2_1: 'sm-2*1',
  /** 1*2 */
  SMALL_1_2: 'sm-1*2',
  /** 1*1 */
  LARGE: 'lg-1*1',
  /** 1*1 */
  LARGE_3_2: 'lg-3*2'
} as const;

export const SERIES_2_LEGEND_TYPE_MAP = {
  line: LEGEND_TYPE.Line,
  lineCircle: LEGEND_TYPE.RoundWithLine,
  bar: LEGEND_TYPE.Rect,
  pie: LEGEND_TYPE.Round,
  voronoi: LEGEND_TYPE.Round,
  $$common: LEGEND_TYPE.Rect,
  scatter: LEGEND_TYPE.Round,
  treemap: LEGEND_TYPE.Rect,
  bar3D: LEGEND_TYPE.Rect,
  scatter3D: LEGEND_TYPE.Round,
  polarBar: LEGEND_TYPE.Round,
  waterfall: LEGEND_TYPE.Rect,
  dvScatter: LEGEND_TYPE.Round,
  dvRankLine: LEGEND_TYPE.Line,
  graph: LEGEND_TYPE.Round,
  radar: LEGEND_TYPE.RoundWithLine,
  tree: LEGEND_TYPE.Rect
} as const;

/** 柱宽的最大宽度由设计师决定32px */
export const BAR_MAX_WIDTH = 14;

/** 网格线的最大等分数 */
export const MAX_SPLIT_LINE_NUMBER = 7;

/** axisPointer为shadow时，阴影的面积是柱宽的倍数 */
export const SHADOW_WIDTH_RATIO = 1.5;

/** 行情图颜色数组 */
export const HXKLINE_COLOR = ['#60656C', '#FA3532', '#00907A'];
